<template>
    <section>
        <div class="left">
            <h2 v-translate>Párování zařízení QR kódem</h2>
        </div>
        <div class="right">
            <text-input
                id="qrcodepairingurltemplate"
                v-model="entity.qr_code_pairing_url_template"
                ref="qrcodepairingurltemplateref"
                :disabled="!isEditable"
                :help-text="$gettext('Příklad https://[url]/#/pair/{language}/{challenge_token}/. Parametr {challenge_token} je povinný')"
            ><translate class="translate">Šablona pro párování QR kódem</translate>
            </text-input>
          <a v-if="entity.id && hasDomains" @click.stop.prevent="generateDefaultTemplate" class="btn" :title="'Vygenerovat výchozí šablonu' | translate" v-translate>Generovat výchozí</a>
        </div>
    </section>
</template>

<script>
	export default {
		name: "ShopUrls",
		props: {
      isEditable: Boolean,
			entity: Object,
		},
    computed: {
      hasDomains(){
        return this.entity.domains.length > 0;
      }
    },
    methods: {
      generateDefaultTemplate(){
        if(!this.hasDomains){
          return;
        }
        this.entity.qr_code_pairing_url_template = 'https://'+this.entity.domains[0].domain + '/#/pair/{challenge_token}/{language}';
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/forms/QrCodePairing.vue